module.exports = __webpack_public_path__ + "static/media/darbar.9728cb9e.jpg";